import React from 'react';
import { Link } from 'react-router-dom';
import Button from '@/components/ui/Button';
import Logo from '@/components/ui/Logo';
import { Helmet } from 'react-helmet-async';

const NotFound: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-neutral-50 p-6 text-center">
      <Helmet>
        <title>Page Not Found - ImmStack</title>
      </Helmet>
      <div className="flex justify-center mb-6">
        <Logo size="md" />
      </div>
      <h1 className="text-3xl font-semibold text-neutral-900 mb-4">
        404 - Page Not Found
      </h1>
      <p className="text-neutral-600 max-w-md mb-8">
        The page you are looking for does not exist or has been moved.
      </p>
      <Link to="/cases">
        <Button>Back to Dashboard</Button>
      </Link>
    </div>
  );
};

export default NotFound;
